import { __read } from "tslib";
import React, { useMemo } from 'react';
import { Avatar } from '@hose/eui';
import { sortBy } from 'lodash';
import clx from 'classnames';
import { availableBaseFields } from './config';
import { Item } from './item';
import { extractFieldInfo, isAvailableBaseField } from './utils';
import { getDisplayName } from '../utilFn';
import styles from './profile-card.module.less';
var FieldsMustInclude = ['name', 'nickName', 'avatar'];
export var ProfileCard = function (_a) {
    var dataSource = _a.dataSource, selectedFields = _a.selectedFields, className = _a.className, maxHeight = _a.maxHeight;
    var selectedCustomFields = useMemo(function () {
        var _selectedCustomFields = selectedFields.filter(function (field) { return !isAvailableBaseField(field) && !FieldsMustInclude.includes(field); });
        if (Array.isArray(dataSource.order)) {
            return sortBy(_selectedCustomFields, function (field) {
                return dataSource.order.indexOf(field);
            });
        }
        else {
            return _selectedCustomFields;
        }
    }, [selectedFields, dataSource]);
    var renderBaseField = function () {
        return availableBaseFields
            .filter(function (_a) {
            var _b = __read(_a, 1), field = _b[0];
            return !FieldsMustInclude.includes(field);
        })
            .filter(function (_a) {
            var _b = __read(_a, 1), field = _b[0];
            return selectedFields.includes(field);
        })
            .map(function (_a) {
            var _b = __read(_a, 2), field = _b[0], label = _b[1];
            var info = extractFieldInfo(field, dataSource);
            return (React.createElement(Item, { key: field, label: label(), value: getDisplayName({ name: info.value, enName: info.enValue }) || i18n.get('无') }));
        });
    };
    var renderCustomFields = function () {
        return selectedCustomFields.map(function (field) {
            var info = extractFieldInfo(field, dataSource);
            return (React.createElement(Item, { key: field, label: getDisplayName(info), value: getDisplayName({ name: info.value, enName: info.enValue }) || i18n.get('无') }));
        });
    };
    var customStyle = maxHeight ? { maxHeight: maxHeight } : {};
    var usernameInfo = useMemo(function () {
        return {
            name: extractFieldInfo('name', dataSource).value || '',
            nickName: extractFieldInfo('nickName', dataSource).value || '',
            avatar: extractFieldInfo('avatar', dataSource).value,
        };
    }, [dataSource]);
    var ifShowNickName = useMemo(function () {
        var isSelected = selectedFields.includes('nickName');
        if (!isSelected) {
            return null;
        }
        return (React.createElement(React.Fragment, null, usernameInfo.nickName ? (React.createElement("span", { className: styles.nickname },
            "\uFF08",
            usernameInfo.nickName,
            "\uFF09")) : null));
    }, [selectedFields, usernameInfo.nickName]);
    return (React.createElement("section", { className: clx(styles['profile-card'], className), style: customStyle },
        React.createElement("div", { className: styles['name-wrapper'] },
            React.createElement(Avatar, { size: "large", src: usernameInfo.avatar }),
            React.createElement("span", { className: styles.name }, usernameInfo.name),
            ifShowNickName),
        React.createElement("ul", { className: styles.profile },
            renderBaseField(),
            renderCustomFields())));
};
